import React from 'react';

/**
 * Display user's featured badges inline (next to username)
 * Used in posts, comments, user profiles, etc.
 */
const FeaturedBadges = ({ badges = [], size = 'sm' }) => {
  if (!badges || badges.length === 0) return null;

  const sizeClasses = {
    xs: 'w-4 h-4',
    sm: 'w-5 h-5',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  const sizeClass = sizeClasses[size] || sizeClasses.sm;

  return (
    <div className="inline-flex items-center gap-1 ml-2">
      {badges.slice(0, 3).map((badge, index) => {
        const badgeUrl = badge.badge_url || badge.icon_url || badge;
        
        // Handle emoji badges
        if (typeof badgeUrl === 'string' && !badgeUrl.startsWith('http')) {
          return (
            <span
              key={index}
              className="inline-block"
              style={{ fontSize: size === 'lg' ? '1.5rem' : size === 'md' ? '1.2rem' : '1rem' }}
              title={badge.badge_name || 'Featured Badge'}
            >
              {badgeUrl}
            </span>
          );
        }

        // Handle image badges
        return (
          <img
            key={index}
            src={badgeUrl}
            alt={badge.badge_name || 'Featured Badge'}
            className={`${sizeClass} object-contain inline-block`}
            title={badge.badge_name || 'Featured Badge'}
          />
        );
      })}
    </div>
  );
};

export default FeaturedBadges;
